<template>
    <div class="aged-receivable">
        <base-header >
            <b-row>
                <b-col cols="12">
                    <router-link :to="'/reporting'" class="text-primary">
                        <b-icon icon="chevron-left"></b-icon>
                        Back
                    </router-link>
                </b-col>
            </b-row>
			<b-row align-v="center" class="py-3">
				<b-col lg="6" cols="7">
					<h2 class="text-xl d-inline-block mb-0">Aged Receivable</h2>
                    <p class="text-muted">Last updated 2 days ago</p>
				</b-col>
				<b-col cols="6" class="text-right text-primary">
					<el-button type="primary" class="mr-4">
                        <div class="d-flex align-items-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" class="mr-2" viewBox="0 0 512 512"><path fill="currentColor" d="M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v242.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7zM64 352c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64h384c35.3 0 64-28.7 64-64v-32c0-35.3-28.7-64-64-64H346.5l-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352zm368 56a24 24 0 1 1 0 48a24 24 0 1 1 0-48"/></svg>
                            Download Report
                        </div>
                    </el-button>
				</b-col>
			</b-row>
		</base-header>
        <b-container fluid>
            <b-card no-body>
                <b-card-header class="border-0">
                    <b-row ></b-row>
                </b-card-header>

                <b-col cols="12">
                    <b-row class="d-flex align-items-center justify-content-md-between">
                        <b-col cols="12" md="8" class="d-md-flex">
                            <base-input
                                v-model="searchQuery"
                                v-on:input="debouncedHandler"
                                placeholder="Search Name, Case ID, Ref..."
                            >
                            </base-input>

                            <base-input class="mx-4">
                                <el-select
                                    v-model="aging_by"
                                    multiple
                                    collapse-tags
                                    placeholder="Select Status"
                                >
                                    <el-option
                                        v-for="item in agingList"
                                        :key="item.status_id"
                                        :label="item.status"
                                        :value="item.status_id"
                                    >
                                    </el-option>
                                </el-select>
                            </base-input>
                        </b-col>
                        <b-col cols="12" md="4">
                            <b-row class="d-flex align-items-center justify-content-md-end">
                                <b-col cols="auto" class="mb-3 float-right">
                                    <el-select
                                        v-model="sort_by"
                                        multiple
                                        collapse-tags
                                        placeholder="Sort By"
                                    >
                                        <el-option
                                            v-for="item in sortByList"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value"
                                        >
                                        </el-option>
                                    </el-select>
                                </b-col>
                                <b-col cols="auto" class="mb-3">
                                    <el-date-picker
                                        v-model="period"
                                        type="date"
                                        placeholder="Pick a day"
                                    ></el-date-picker>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </b-col>

                <div class="table-simple">
                    <b-table-simple bordered responsive>
                        <b-thead>
                            <b-tr>
                                <b-th class="text-center">#</b-th>
                                <b-th rowspan="2" class="border-right">Customer (Ref. No)/<br> Case Details</b-th>
                                <b-th colspan="5">Outstanding Amt. (RM)</b-th>
                                <b-th rowspan="2" class="border-left">Total Outstanding<br> Amount (RM)</b-th>
                            </b-tr>
                            <b-tr>
                                <b-th colspan="2"></b-th>
                                <b-th>&lt; 1 months </b-th>
                                <b-th>1 months</b-th>
                                <b-th>2 months</b-th>
                                <b-th>3 months</b-th>
                                <b-th>Older</b-th>
                            </b-tr>
                        </b-thead>
                        <b-tbody>
                            <b-tr class="bg-success">
                                <b-td>1</b-td>
                                <b-td>
                                    Ben Mu
                                    <svg xmlns="http://www.w3.org/2000/svg" width="6" height="6" viewBox="0 0 512 512"><path fill="#C1C4D0" d="M256 512a256 256 0 1 0 0-512a256 256 0 1 0 0 512"/></svg>
                                    FVG - 22/0126/SAS
                                </b-td>
                                <b-td class="text-right font-weight-600">{{ 0 | moneyFormatter }}</b-td>
                                <b-td class="text-right font-weight-600">{{ 1800 | moneyFormatter }}</b-td>
                                <b-td class="text-right font-weight-600">{{ 2000 | moneyFormatter }}</b-td>
                                <b-td class="text-right font-weight-600">{{ 3000 | moneyFormatter }}</b-td>
                                <b-td class="text-right font-weight-600">{{ 3700 | moneyFormatter }}</b-td>
                                <b-td class="font-weight-600">{{ 10500 | moneyFormatter }}</b-td>
                            </b-tr>
                            <b-tr>
                                <b-td></b-td>
                                <b-td>
                                    <p class="text-primary">Case #2861-TKO</p>
                                    <p class="font-weight-600">Loan Amt: RM {{ 25000 | moneyFormatter }}</p>
                                    <p class="text-primary">Invoice #INV-2861</p>
                                    <p class="text-primary">Invoice #INV-2862</p>
                                    <p class="text-primary cursor-pointer">View All</p>
                                </b-td>
                                <b-td>
                                    <p class="text-right text-xs text-muted">Instalm. + Late - Waive</p>
                                    <div class="d-flex align-items-center justify-content-between">
                                        <p>UTD</p>
                                        <p>{{ 0 | moneyFormatter }}</p>
                                    </div>
                                    <div class="d-flex align-items-center justify-content-between">
                                        <p>MTH</p>
                                        <p>{{ 0 | moneyFormatter }}</p>
                                    </div>
                                    <div class="d-flex align-items-center justify-content-between">
                                        <p>Total Paid</p>
                                        <p>{{ 700 | moneyFormatter }}</p>
                                    </div>
                                    <div class="d-flex align-items-center justify-content-between">
                                        <p class="font-weight-600">O/S</p>
                                        <p class="font-weight-600">{{ 0 | moneyFormatter }}</p>
                                    </div>
                                </b-td>
                                <b-td>
                                    <p class="text-right text-xs text-muted">Instalm. + Late - Waive</p>
                                    <div class="d-flex align-items-center justify-content-between">
                                        <p>UTD</p>
                                        <p>{{ 2500 | moneyFormatter }}</p>
                                    </div>
                                    <div class="d-flex align-items-center justify-content-between">
                                        <p>MTH</p>
                                        <p>{{ 2500 | moneyFormatter }}</p>
                                    </div>
                                    <div class="d-flex align-items-center justify-content-between">
                                        <p>Total Paid</p>
                                        <p>{{ 700 | moneyFormatter }}</p>
                                    </div>
                                    <div class="d-flex align-items-center justify-content-between">
                                        <p class="font-weight-600">O/S</p>
                                        <p class="font-weight-600">{{ 1800 | moneyFormatter }}</p>
                                    </div>
                                </b-td>
                                <b-td>
                                    <p class="text-right text-xs text-muted">Instalm. + Late - Waive</p>
                                    <div class="d-flex align-items-center justify-content-between">
                                        <p>UTD</p>
                                        <p>{{ 3800 | moneyFormatter }}</p>
                                    </div>
                                    <div class="d-flex align-items-center justify-content-between">
                                        <p>MTH</p>
                                        <p>{{ 2700 | moneyFormatter }}</p>
                                    </div>
                                    <div class="d-flex align-items-center justify-content-between">
                                        <p>Total Paid</p>
                                        <p>{{ 700 | moneyFormatter }}</p>
                                    </div>
                                    <div class="d-flex align-items-center justify-content-between">
                                        <p class="font-weight-600">O/S</p>
                                        <p class="font-weight-600">{{ 2000 | moneyFormatter }}</p>
                                    </div>
                                </b-td>
                                <b-td>
                                    <p class="text-right text-xs text-muted">Instalm. + Late - Waive</p>
                                    <div class="d-flex align-items-center justify-content-between">
                                        <p>UTD</p>
                                        <p>{{ 4500 | moneyFormatter }}</p>
                                    </div>
                                    <div class="d-flex align-items-center justify-content-between">
                                        <p>MTH</p>
                                        <p>{{ 2900 | moneyFormatter }}</p>
                                    </div>
                                    <div class="d-flex align-items-center justify-content-between">
                                        <p>Total Paid</p>
                                        <p>{{ 700 | moneyFormatter }}</p>
                                    </div>
                                    <div class="d-flex align-items-center justify-content-between">
                                        <p class="font-weight-600">O/S</p>
                                        <p class="font-weight-600">{{ 2200 | moneyFormatter }}</p>
                                    </div>
                                </b-td>
                                <b-td>
                                    <p class="text-right text-xs text-muted">Instalm. + Late - Waive</p>
                                    <div class="d-flex align-items-center justify-content-between">
                                        <p>UTD</p>
                                        <p>{{ 5200 | moneyFormatter }}</p>
                                    </div>
                                    <div class="d-flex align-items-center justify-content-between">
                                        <p>MTH</p>
                                        <p>{{ 3300 | moneyFormatter }}</p>
                                    </div>
                                    <div class="d-flex align-items-center justify-content-between">
                                        <p>Total Paid</p>
                                        <p>{{ 700 | moneyFormatter }}</p>
                                    </div>
                                    <div class="d-flex align-items-center justify-content-between">
                                        <p class="font-weight-600">O/S</p>
                                        <p class="font-weight-600">{{ 2500 | moneyFormatter }}</p>
                                    </div>
                                </b-td>
                                <b-td style="vertical-align: top;">{{ 8500 | moneyFormatter }}</b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                </div>
            </b-card>
        </b-container>
    </div>
</template>
<script>
import { Button, Select, Option, DatePicker } from 'element-ui'
import clientPaginationMixin from '@/assets/js/clientPaginationMixin'

export default {
    mixins: [clientPaginationMixin],
    components: {
        [Button.name]: Button,
        [Select.name]: Select,
        [Option.name]: Option,
        [DatePicker.name]: DatePicker,
    },
    data() {
        return {
            debouncedHandler: '',
            aging_by: 'Aging by Due Date',
            agingList: [
                {
                status_id: 'Aging by Due Date',
                status: 'Aging by Due Date',
                },
                {
                status_id: 'Aging by A to Z',
                status: 'Aging by A to Z',
                },
            ],
            sort_by: '',
            sortByList: [
                {
                    value: 'Outstanding Amount',
                    label: 'Outstanding Amount',
                },
                {
                    value: 'Alphabet',
                    label: 'Alphabet',
                },
            ],
            period: '',
        }
    },
    mounted(){
        this.debouncedHandler = debounce(() => {
        // this.searchFinancialProposalList();
        }, 500);
    },
}
</script>